<template>
  <div class="headerBg">
    <div class="width12">
      <div class="first">欢迎访问优师优库~</div>
      <div class="second">
        <router-link class="poin" to="/" tag="div">首页</router-link>
        <div @click="authClick" v-if="showAuth" class="poin">教师认证</div>
        <!-- <router-link @click="authClick" v-if="showAuth" class="poin" to="/authentication" tag="div">教师认证</router-link> -->
        <router-link class="poin" to="/catalog" tag="div">书目下载</router-link>
        <div>
          <div class="wxcodeimg">
            <img class="phone" src="../../assets/img/phone.png" />
            <span class="imgtext">小程序</span>
            <div class="wxcode">
              <img class="barcode" src="../../assets/img/wxi.jpg" alt="" />
              <p class="scan">扫一扫</p>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { api } from '../../assets/api/axios'
export default {
  data() {
    return {
      showAuth: false,
    }
  },
  created() {
    let token = window.localStorage.getItem('token')
    if (token == '' || token == null) {
    } else {
      this.showAuth = true
    }
  },
  methods: {
    async authClick() {
      var res = await api.post('/front/personal/myMessage')
      if (res.code == 1000) {
        if (res.data.status == 0) {
          this.$router.push({
            path: '/authentication',
          })
        } else if (res.data.status == 1) {
          this.$message.success('教师认证中')
        } else {
          this.$message.success('教师认证已通过')
        }
      }
    },
  },
}
</script>
<style lang="scss" scoped>
.poin {
  cursor: pointer;
}
.width12 {
  width: 1112px;
  margin: 0 auto;
  height: 100%;
}
.phone {
  width: 10px;
  height: 17px;
  vertical-align: middle;
  display: inline-block;
  margin-right: 5px;
}
.wxcode {
  position: absolute;
  left: -55px;
  top: 45px;
  width: 122px;
  height: 143px;
  background: #ffffff;
  box-shadow: 0px 4px 10px 0px rgba(0, 0, 0, 0.21);
  display: none;
  z-index: 100;
  .barcode {
    width: 100px;
    height: 100px;
    margin: 8px;
  }
}
.scan {
  text-align: center;
  font-size: 12px;
  font-family: Source Han Sans CN;
  font-weight: 400;
  color: #666666;
}

.wxcodeimg:hover .wxcode {
  display: block;
}
.wxcodeimg {
  position: relative;
}
.headerBg {
  width: 100%;
  height: 36px;
  background: rgba(38, 38, 38, 1);
  .width12 {
    color: #fff;
    font-size: 13px;
    .first {
      float: left;
      margin-top: 12px;
    }
    .second {
      float: right;
      margin-top: 12px;
      div {
        float: left;
        margin-left: 20px;
        cursor: pointer;
        &:hover {
          color: #b50e05ff;
        }
      }
    }
  }
}
</style>
